// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__s6Ija","clinicsSelect":"styles_clinicsSelect__zCMKw"};